import sanity from '@utils/sanity';
import { PageProps } from 'src/@types/page';
import Layout from 'src/layouts';
import { projects as projectsQuery, page as pageQuery } from '@data/queries';
import Routes from 'src/routes';
import { Page } from 'src/components';
import { ProjectProps } from 'src/@types/project';
import { Stack, Typography, styled, Container } from '@mui/material';
import { HEADER_MOBILE_HEIGHT, HEADER_DESKTOP_HEIGHT } from 'src/config';
import ProjectList from 'src/sections/projects/ProjectList';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: HEADER_MOBILE_HEIGHT,
  [theme.breakpoints.up('md')]: {
    paddingTop: HEADER_DESKTOP_HEIGHT,
  },
}));

// ----------------------------------------------------------------------

type Props = {
  projects: ProjectProps[];
  page: PageProps;
};

const ProjectsPage = ({ projects, page }: Props) => {
  return (
    <Page seo={page.seo}>
      <RootStyle>
        <Container>
          <Stack
            spacing={3}
            sx={{
              mt: { xs: 8, md: 10 },
              textAlign: { xs: 'left', md: 'left' },
            }}
          >
            <Typography variant="h2">Prosjekter</Typography>
            <Typography sx={{ color: 'text.secondary' }} maxWidth={600}>
              Vi har gjennom våre {new Date().getFullYear() - 2000} år i markedet gjennomført
              elektroarbeider i mange store bolig- og næringsprosjekter. <br /> Vi jobber med alt
              fra enkle til svært teknisk avanserte prosjekter. Som utbygger eller totalentreprenør
              kan du føle deg trygg på at jobben får den oppmerksomhet som kreves og at kundene blir
              ivaretatt og får individuell oppfølging på best mulig måte.
            </Typography>
          </Stack>

          <ProjectList projects={projects} />
        </Container>
      </RootStyle>
    </Page>
  );
};

// ----------------------------------------------------------------------

ProjectsPage.getLayout = function getLayout(page: React.ReactElement) {
  return <Layout>{page}</Layout>;
};

// ----------------------------------------------------------------------

export const getStaticProps = async () => {
  const projects = await sanity.fetch(projectsQuery(10));
  const page = await sanity.fetch(pageQuery, { slug: Routes.projects });

  return {
    props: { projects, page },
  };
};

export default ProjectsPage;
